import { cn } from '@/lib/utils'
import { ImageIcon } from 'lucide-react'
import { Inter } from 'next/font/google'
import Link from 'next/link'
import Particles from '../magicui/particles'
const inter = Inter({ subsets: ['latin'] })

export const PostCard = ({
  slug,
  srcImg,
  badges,
  altImg,
  title,
  publishDate = new Date(),
  searching = false,
  index,
}: {
  slug: string
  srcImg: string
  badges: string[]
  altImg: string
  title: string
  publishDate: Date
  searching?: boolean
  index?: number
}) => {
  return (
    <Link
      href={`blog/${slug}`}
      aria-label="Blog link"
      className={cn(
        'cursor-pointer p-2 hover:bg-gray-100 rounded-lg col-span-6 sm:col-span-3 lg:col-span-2 row-span-1 flex flex-col gap-4',
        !searching && 'lg:first:row-span-2 lg:first:col-span-4',
      )}
    >
      <div
        className={cn(
          'flex relative bg-[#f8f8f8] border border-primary-treeunfe-nfe/10 rounded-lg min-h-[205px] w-full h-full',
          (index !== 0 || searching) && 'max-h-[170px]',
        )}
      >
        {!srcImg && (
          <Particles
            className="absolute inset-0"
            quantity={100}
            ease={80}
            color={'#016551'}
            refresh
          />
        )}

        {srcImg ? (
          <img
            src={srcImg}
            className="rounded-lg !object-cover"
            alt={altImg || 'Capa do post'}
            loading="lazy"
            title={altImg || 'Capa do post'}
          />
        ) : (
          <ImageIcon className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[#016551]/10 w-16 h-16" />
        )}
      </div>
      <span className="flex gap-2 text-[#01634f] text-nowrap text-sm">
        {badges?.join(', ')}
      </span>
      <div className="flex flex-col gap-0.5">
        <h2
          className={cn(
            inter.className,
            'font-semibold text-lg text-[#323232]',
          )}
        >
          {title}
        </h2>
        <span className="text-xs">
          {publishDate.toLocaleDateString('pt-BR', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </span>
      </div>
    </Link>
  )
}
